/* unplugin-vue-components disabled */import script from "./Class.vue?vue&type=script&setup=true&lang=js"
export * from "./Class.vue?vue&type=script&setup=true&lang=js"

import "./Class.vue?vue&type=style&index=0&id=c73596f0&lang=scss"

const __exports__ = script;

export default __exports__